<template>
  <div id="app">
    <div class="login_box">
      <!-- 头像区 -->
      <div class="avatar_box">
        <img src="../assets/logo3.png" alt="">
      </div>
      <!-- 登录表单区 -->
      <el-form :model="formData" :rules="loginFormRules" ref="formDataRef" label-width="0px" class="login_form">
        <el-form-item prop="accountNumber">
          <el-input placeholder="请输入账号" prefix-icon="el-icon-user" v-model="formData.accountNumber"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码"  prefix-icon="el-icon-search" show-password v-model="formData.password"></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="loginBtn()">登录</el-button>
          <el-button type="info" @click="resetLoginForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user'
export default {
  name: 'App',
  data () {
    return {
      formData: {
        accountNumber: '',
        password: ''
      },
      orgList: [],
      loginFormRules: {
        accountNumber: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 11, max: 18, message: '长度在 11 到 18 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 6, message: '长度不小于6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 重置表单
    resetLoginForm() {
      // 调用表单上的ref="formDataRef"属性调用resetFields()方法重置表单数据
      this.$refs.formDataRef.resetFields()
    },
    loginBtn () {
      // debugger
      // 调用表单上的ref="formDataRef"属性调用validate()方法验证表单数据合法性
      this.$refs.formDataRef.validate(valid => {
        // debugger
        // console.log(valid)
        if (!valid) return
        login(this.formData).then(res => {
          // debugger
          console.log(res.status)
          // 判断是否登录成功
          if (res.status !== 200) return this.$message.error('远程服务器没有响应')
          if (!(res.data.rc === 'succ')) return this.$message.error(res.data.c)
          // this.$message.success('登录成功')
          // 写本地存入token的方法
          this.$store.commit('loginSuccess', res.data.c)// 调用setUserInfo方法将数据同步到vuex
          // localStorage.setItem('userInfo', JSON.stringify(res.data.c.token))
          // console.log(this.$store.state.user)
          this.userName = '' // 清空账号
          this.psw = '' // 清空密码
          this.$router.push('/home')// 跳转页面到主页
        })
      })
    }
  },
  created () {
  },
  components: {
  }
}
</script>

<style lang="less" scoped>
.login_container{
  background-color: #2b4b6b;
  height: 100%;
  margin: 0;
  padding: 0;
}
.login_box{
  width: 28.125rem;
  height: 18.75rem;
  background-color: #fff;
  border-radius: 0.1875rem;
  position: absolute;
  left: 50%;// 左右位移到50%
  top: 50%;// 上下位移到50%
  transform: translate(-50%, -50%);//在横轴和竖轴上位移-50%
  .avatar_box{
    height: 8.125rem;
    width: 8.125rem;
    border-radius: 50%;// 将图片边框成圆形
    padding: 0.625rem;
    box-shadow: 0 0 0.625rem #ddd;
    position: absolute;// 加一个定位为下面移动作准备
    left: 50%;// 右移动50%
    transform: translate(-50%, -50%);// 移动图片自身的-50%
    background-color: #fff;// 为边框加一个白色的背景色
    img{
      width: 100%;
      height: 100%;
      border-radius: 50%;// 将图片边框成圆形
      background-color: #eee;
    }
  }
}
.btns{
  display: flex;// 变成弹性合模型方便下面移动
  justify-content: flex-end;// 右对齐
}
 .login_form{
   position: absolute;// 加一个定位为下面移动作准备
   bottom: 0;// 靠下底部
   width: 100%;
   padding: 0 1.25rem;// 偏移20像素
   box-sizing: border-box;// 让他不能移出框外
 }
</style>
